import { adminHttpClient } from '../../commons/adminHttpClient'

export type ExpenseTypesByCategoryIdForEmployeeResponse = {
  id: number
  name: string
  requireUploadAttachment: boolean
}

export const getExpenseTypesByCategoryIdForEmployee = (
  categoryId: number,
): Promise<ExpenseTypesByCategoryIdForEmployeeResponse[]> => {
  return adminHttpClient.get(`/EEDashboard/Perks/GetExpenseTypesByCategoryIdForEmployee/${categoryId}`, {})
}
